<ng-container>
  <td>{{ integration.config.getTypeDisplayString() }}</td>
  <td class="nowrap">{{ integration.name }}</td>
  <td>
    <button type="button" class="arpio-button" (click)="editIntegration()" title="Reconfigure">
      <i class="fa-utility fa-semibold fa-pen-to-square"></i>
    </button>
    <button type="button" class="arpio-button" (click)="deleteIntegration()" title="Delete">
      <i class="fa-utility fa-semibold fa-trash"></i>
    </button>
  </td>
</ng-container>
